'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/context/LanguageContext';
import { getTranslations } from '@/lib/i18n';

const team = [
  { name: 'Dr. Suresh Babu', role: 'Founder & Managing Trustee', roleKn: 'ಸಂಸ್ಥಾಪಕ ಮತ್ತು ವ್ಯವಸ್ಥಾಪಕ ಟ್ರಸ್ಟಿ', initial: 'S', bio: 'Educationist with 20+ years in community development across Karnataka.', bioKn: 'ಕರ್ನಾಟಕದಾದ್ಯಂತ ಸಮುದಾಯ ಅಭಿವೃದ್ಧಿಯಲ್ಲಿ 20+ ವರ್ಷಗಳ ಅನುಭವ ಹೊಂದಿರುವ ಶಿಕ್ಷಣತಜ್ಞ.' },
  { name: 'Kavitha Reddy', role: 'Program Director', roleKn: 'ಕಾರ್ಯಕ್ರಮ ನಿರ್ದೇಶಕ', initial: 'K', bio: 'Expert in curriculum design and teacher training with a passion for inclusive education.', bioKn: 'ಸಮಗ್ರ ಶಿಕ್ಷಣದ ಬಗ್ಗೆ ಉತ್ಸಾಹ ಹೊಂದಿರುವ ಪಠ್ಯಕ್ರಮ ವಿನ್ಯಾಸ ಮತ್ತು ಶಿಕ್ಷಕ ತರಬೇತಿ ತಜ್ಞ.' },
  { name: 'Mohan Gowda', role: 'Finance & Compliance', roleKn: 'ಹಣಕಾಸು ಮತ್ತು ಅನುಸರಣೆ', initial: 'M', bio: 'Chartered Accountant ensuring financial transparency and regulatory compliance.', bioKn: 'ಆರ್ಥಿಕ ಪಾರದರ್ಶಕತೆ ಮತ್ತು ನಿಯಂತ್ರಕ ಅನುಸರಣೆ ಖಾತ್ರಿಪಡಿಸುವ ಚಾರ್ಟರ್ಡ್ ಅಕೌಂಟೆಂಟ್.' },
  { name: 'Preethi Nair', role: 'Community Outreach Head', roleKn: 'ಸಮುದಾಯ ಸಂಪರ್ಕ ಮುಖ್ಯಸ್ಥ', initial: 'P', bio: "Social worker with deep roots in Bengaluru\'s underserved communities.", bioKn: 'ಬೆಂಗಳೂರಿನ ಅಸಹಾಯಕ ಸಮುದಾಯಗಳಲ್ಲಿ ಆಳವಾದ ಬೇರುಗಳನ್ನು ಹೊಂದಿರುವ ಸಮಾಜ ಕಾರ್ಯಕರ್ತ.' },
];

const milestones = [
  { year: '2010', event: 'Arivu Foundation registered as a public charitable trust in Bengaluru.', eventKn: 'ಅರಿವು ಫೌಂಡೇಶನ್ ಬೆಂಗಳೂರಿನಲ್ಲಿ ಸಾರ್ವಜನಿಕ ದಾನಧರ್ಮ ಟ್ರಸ್ಟ್ ಆಗಿ ನೋಂದಾಯಿಸಲ್ಪಟ್ಟಿತು.' },
  { year: '2012', event: 'Launched first after-school education center serving 120 students.', eventKn: '120 ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಸೇವೆ ಸಲ್ಲಿಸುವ ಮೊದಲ ಶಾಲೆಯ ನಂತರದ ಶಿಕ್ಷಣ ಕೇಂದ್ರ ಪ್ರಾರಂಭ.' },
  { year: '2015', event: 'Received 12A and 80G certification from Income Tax Department.', eventKn: 'ಆದಾಯ ತೆರಿಗೆ ಇಲಾಖೆಯಿಂದ 12A ಮತ್ತು 80G ಪ್ರಮಾಣಪತ್ರ ಪಡೆದರು.' },
  { year: '2017', event: 'Expanded to 10 communities; launched scholarship program.', eventKn: '10 ಸಮುದಾಯಗಳಿಗೆ ವಿಸ್ತರಿಸಿ; ವಿದ್ಯಾರ್ಥಿವೇತನ ಕಾರ್ಯಕ್ರಮ ಪ್ರಾರಂಭ.' },
  { year: '2019', event: 'Teacher Training program launched in partnership with government schools.', eventKn: 'ಸರ್ಕಾರಿ ಶಾಲೆಗಳ ಸಹಭಾಗಿತ್ವದಲ್ಲಿ ಶಿಕ್ಷಕ ತರಬೇತಿ ಕಾರ್ಯಕ್ರಮ ಪ್ರಾರಂಭ.' },
  { year: '2022', event: 'Crossed 10,000 beneficiaries milestone; launched Women Empowerment program.', eventKn: '10,000 ಫಲಾನುಭವಿಗಳ ಮೈಲಿಗಲ್ಲು ದಾಟಿ; ಮಹಿಳಾ ಸಬಲೀಕರಣ ಕಾರ್ಯಕ್ರಮ ಪ್ರಾರಂಭ.' },
  { year: '2024', event: 'Community Health initiative reaches 45+ communities across Bengaluru.', eventKn: 'ಸಮುದಾಯ ಆರೋಗ್ಯ ಉಪಕ್ರಮ ಬೆಂಗಳೂರಿನಾದ್ಯಂತ 45+ ಸಮುದಾಯಗಳನ್ನು ತಲುಪಿತು.' },
];

export default function AboutPage() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  const kn = language === 'kn';

  return (
    <div className="bg-white min-h-screen">
      <Header />
      <main className="pt-24">
        {/* Hero */}
        <section className="hero-gradient py-20 px-6 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-sm mb-8 ${kn ? 'font-kannada' : ''}`}>
              {t?.about?.badge}
            </div>
            <h1 className={`text-4xl sm:text-5xl font-bold mb-4 ${kn ? 'font-kannada' : ''}`}>
              {t?.about?.heroTitle}<br />
              <span className="text-saffron-light">{t?.about?.heroHighlight}</span>
            </h1>
            <p className={`text-white/75 text-lg max-w-2xl mx-auto ${kn ? 'font-kannada' : ''}`}>
              {t?.about?.heroSubtitle}
            </p>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-10">
              <div className="bg-saffron-pale rounded-3xl p-10 border border-saffron/10">
                <div className="w-12 h-12 rounded-2xl bg-saffron flex items-center justify-center mb-6">
                  <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/>
                  </svg>
                </div>
                <h2 className={`text-2xl font-bold text-indigo mb-3 ${kn ? 'font-kannada' : ''}`}>{t?.about?.missionTitle}</h2>
                <p className={`text-neutral-700 leading-relaxed ${kn ? 'font-kannada' : ''}`}>{t?.about?.missionText}</p>
              </div>
              <div className="bg-indigo-pale rounded-3xl p-10 border border-indigo/10">
                <div className="w-12 h-12 rounded-2xl bg-indigo flex items-center justify-center mb-6">
                  <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                  </svg>
                </div>
                <h2 className={`text-2xl font-bold text-indigo mb-3 ${kn ? 'font-kannada' : ''}`}>{t?.about?.visionTitle}</h2>
                <p className={`text-neutral-700 leading-relaxed ${kn ? 'font-kannada' : ''}`}>{t?.about?.visionText}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-16 bg-surface-muted">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className={`text-3xl font-bold text-indigo mb-2 ${kn ? 'font-kannada' : ''}`}>{kn ? 'ನಮ್ಮ ಮೌಲ್ಯಗಳು' : 'Our Core Values'}</h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                { value: kn ? 'ಪಾರದರ್ಶಕತೆ' : 'Transparency', icon: '🔍', desc: kn ? 'ಮುಕ್ತ ಲೆಕ್ಕಪತ್ರ, ಪ್ರಕಟಿತ ವರದಿಗಳು, ಜವಾಬ್ದಾರಿ ಆಡಳಿತ.' : 'Open books, published reports, accountable governance.' },
                { value: kn ? 'ಸಮಾವೇಶ' : 'Inclusion', icon: '🤝', desc: kn ? 'ಅತ್ಯಂತ ಅಂಚಿನಲ್ಲಿರುವವರನ್ನು ತಲುಪಲು ವಿನ್ಯಾಸಗೊಳಿಸಿದ ಪ್ರತಿ ಕಾರ್ಯಕ್ರಮ.' : 'Every program designed to reach the most marginalized.' },
                { value: kn ? 'ಸಹಾನುಭೂತಿ' : 'Empathy', icon: '❤️', desc: kn ? 'ಸಮುದಾಯ-ಮೊದಲ ವಿಧಾನ, ಕ್ರಿಯೆಗೆ ಮೊದಲು ಆಲಿಸುವುದು.' : 'Community-first approach, listening before acting.' },
                { value: kn ? 'ಪ್ರಭಾವ' : 'Impact', icon: '📈', desc: kn ? 'ಅಳೆಯಬಹುದಾದ ಫಲಿತಾಂಶಗಳು, ಡೇಟಾ-ಆಧಾರಿತ ನಿರ್ಧಾರಗಳು.' : 'Measurable outcomes, data-driven decisions.' },
              ]?.map((v) => (
                <div key={v?.value} className="bg-white rounded-2xl p-6 text-center shadow-card hover-lift">
                  <div className="text-3xl mb-3">{v?.icon}</div>
                  <h3 className={`font-bold text-indigo mb-2 ${kn ? 'font-kannada' : ''}`}>{v?.value}</h3>
                  <p className={`text-neutral-600 text-sm ${kn ? 'font-kannada' : ''}`}>{v?.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className={`text-3xl font-bold text-indigo mb-2 ${kn ? 'font-kannada' : ''}`}>{t?.about?.historyTitle}</h2>
            </div>
            <div className="relative">
              <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-saffron via-crimson to-indigo"></div>
              <div className="space-y-8">
                {milestones?.map((m) => (
                  <div key={m?.year} className="flex gap-6 pl-4">
                    <div className="relative flex-shrink-0">
                      <div className="w-8 h-8 rounded-full bg-white border-2 border-saffron flex items-center justify-center z-10 relative">
                        <div className="w-2 h-2 rounded-full bg-saffron"></div>
                      </div>
                    </div>
                    <div className="pb-2">
                      <span className="inline-block px-3 py-1 bg-saffron-pale text-saffron text-xs font-bold rounded-full mb-2">{m?.year}</span>
                      <p className={`text-neutral-700 text-sm leading-relaxed ${kn ? 'font-kannada' : ''}`}>{kn ? m?.eventKn : m?.event}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="py-20 bg-surface-muted">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className={`text-3xl font-bold text-indigo mb-2 ${kn ? 'font-kannada' : ''}`}>{kn ? 'ನಾಯಕತ್ವ ತಂಡ' : 'Leadership Team'}</h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {team?.map((member) => (
                <div key={member?.name} className="bg-white rounded-2xl p-6 text-center shadow-card hover-lift">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-saffron to-crimson flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4">{member?.initial}</div>
                  <h3 className="font-bold text-neutral-900 mb-1">{member?.name}</h3>
                  <p className={`text-saffron text-xs font-semibold mb-3 ${kn ? 'font-kannada' : ''}`}>{kn ? member?.roleKn : member?.role}</p>
                  <p className={`text-neutral-600 text-xs leading-relaxed ${kn ? 'font-kannada' : ''}`}>{kn ? member?.bioKn : member?.bio}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Certifications */}
        <section className="py-16 bg-indigo text-white">
          <div className="max-w-5xl mx-auto px-6">
            <div className="text-center mb-10">
              <h2 className={`text-3xl font-bold mb-2 ${kn ? 'font-kannada' : ''}`}>{kn ? 'ನೋಂದಣಿ ಮತ್ತು ಪ್ರಮಾಣಪತ್ರಗಳು' : 'Registrations & Certifications'}</h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                { label: kn ? 'ಟ್ರಸ್ಟ್ ನೋಂದಣಿ' : 'Trust Registration', value: 'TRUST_REG_NUMBER', icon: '📋' },
                { label: kn ? '12A ಪ್ರಮಾಣಪತ್ರ' : '12A Certification', value: '12A_CERT_NUMBER', icon: '✅' },
                { label: kn ? '80G ಪ್ರಮಾಣಪತ್ರ' : '80G Certification', value: '80G_CERT_NUMBER', icon: '🏛️' },
                { label: kn ? 'FCRA (ಬಾಕಿ)' : 'FCRA (Pending)', value: 'FCRA_REG_NUMBER', icon: '🌐' },
              ]?.map((cert) => (
                <div key={cert?.label} className="bg-white/10 rounded-2xl p-6 text-center border border-white/10">
                  <div className="text-3xl mb-3">{cert?.icon}</div>
                  <div className={`font-bold text-white mb-1 ${kn ? 'font-kannada' : ''}`}>{cert?.label}</div>
                  <div className="text-white/50 text-xs font-mono">{cert?.value}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
